<template>
	<v-container fluid>
		<SignalR path="/hub/mantenimiento" @change="onChangeSocket" />

		<v-row>
			<v-col cols="12">
				<TitleHeader
					title="Actividades Pendientes"
					:loading="loading"
					:isMobile="isMobile"
					@click:btn="onRefresh"
				/>
			</v-col>
			<template v-if="loading">
				<LoadingData :isMobile="isMobile" />
			</template>
			<template v-if="hayData">
				<v-col cols="12">
					<ActividadesFiltros />
				</v-col>
				<v-col
					v-for="(actividad, index) in actividadesComputed"
					:cols="computedColsCard"
					:key="`actividad-${index}`"
					class="flex d-flex"
				>
					<ActividadCard
						:actividad="actividad"
						:isMobile="isMobile"
						@click="onClickCard"
					/>
				</v-col>
			</template>
			<template v-if="noHayData || filtradoSinData">
				<NoData :isMobile="isMobile" />
			</template>
		</v-row>
	</v-container>
</template>

<script>
import axios from "axios";
import LoadingData from "../shared/LoadingData.vue";
import NoData from "../shared/NoData.vue";
import TitleHeader from "../shared/TitleHeader.vue";
import ActividadesFiltros from './ActividadesFiltros.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { defineAsyncComponent } from 'vue';

export default {
	components: { 
		ActividadCard: defineAsyncComponent(() => import("./ActividadCard.vue")),
		LoadingData,
		TitleHeader,
		NoData,
		ActividadesFiltros
	},
	data() {
		return {
			actividades: [],
			loading: false,
			idPersona: null,
		};
	},
	computed: {
		...mapState(['filtros','tiposEstados']),
		...mapGetters(['numFiltrosAplicados']),
		filtradoSinData(){
			return !this.loading && this.actividadesComputed.length == 0;
		},
		actividadesComputed(){
			return this.numFiltrosAplicados > 0
				? this.actividades.filter( (actividad) => this.checkFiltersActividad(actividad))
				: this.actividades;
		},
		isMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
		computedColsCard() {
			return this.isMobile ? "12" : "6";
		},
		hayData() {
			return !this.loading && this.actividades.length > 0;
		},
		noHayData() {
			return !this.loading && this.actividades.length == 0;
		},
	},
	mounted() {
		this.initialize();
	},
	methods: {
		...mapActions(['getParsedParams']),
		mecanicoEstaAsignado(actividad) {
			return actividad.mecanicos?.some(
				(mecanico) => mecanico.idPersona == actividad.idPersona
			) || false;
		},
		checkFiltersActividad(actividad){
			let filtrados = 0;
			if(
				this.filtros.tipoMantenimiento != null &&
				actividad.tipo == this.filtros.tipoMantenimiento
			){
				filtrados += 1;
			}

			if(this.filtros.nombreMantenimiento){
				const parsedNombre = this.filtros.nombreMantenimiento.toLowerCase().trim();
				const nombreMantenimiento = `[${actividad.codigo}] - ${actividad.nombre}`.toLocaleLowerCase().trim();
				if (nombreMantenimiento.includes(parsedNombre)) filtrados += 1;
			}

			if(this.filtros.nombreMaquina){
				const parsedNombre = this.filtros.nombreMaquina.toLowerCase().trim();
				const nombreMaquina = actividad.maquinaIns.toLocaleLowerCase().trim();
				if (nombreMaquina.includes(parsedNombre)) filtrados += 1;
			}
			
			if(Array.isArray(this.filtros.fecha) ? this.filtros.fecha.length > 0 : this.filtros.fecha){
				let matchFecha = false;
				if(Array.isArray(this.filtros.fecha)) matchFecha = this.filtros.fecha.includes(actividad.inicio);
				else matchFecha = this.filtros.fecha == actividad.inicio;
				if(matchFecha) filtrados += 1;
			}

			return this.numFiltrosAplicados == filtrados;
		},
		async onChangeSocket(event) {
			const parsedParams = await this.getParsedParams(event);

			const actividadAsignada = this.actividades.find((actividad) => {
				const dynamicKey =
					actividad.tipo == 3
						? "idMantenimientoCalendarioInspeccion"
						: "idMantenimientoTarea";

				return parsedParams[dynamicKey] == actividad[dynamicKey];
			});

			if (parsedParams.estado == this.tiposEstados["asignar"]) {
				if (
					this.idPersona == parsedParams.idPersona ||
					actividadAsignada
				)
					this.getActividades();
			} else if (
				parsedParams.estado == this.tiposEstados["iniciar"] ||
				parsedParams.estado == this.tiposEstados["finalizar"] ||
				parsedParams.estado == this.tiposEstados["unirse"] ||
				parsedParams.estado == this.tiposEstados["pausar"] ||
				parsedParams.estado == this.tiposEstados["salirse"]
			) {
				if (actividadAsignada){
					this.getActividades();
				}
			}
		},
		onRefresh() {
			this.initialize();
		},
		getActividades() {
			this.loading = true;

			axios
				.get("/Mecanicos/MantenimientosAsignados")
				.then((response) => {
					if(response.data){
						this.actividades = response.data.asignaciones.map((actividad) => ({
							...actividad,
							idPersona: response.data.idPersona,
						})).sort( (a,b) => {
							if(a.enCurso && this.mecanicoEstaAsignado(a)) return -1;
							else if(b.enCurso && this.mecanicoEstaAsignado(b)) return 1;
							else if(a.enCurso && a.tiempoPeriodosMs > 0) return -1;
							else if(b.enCurso && b.tiempoPeriodosMs > 0) return 1;
							else if(a.enCurso) return -1;
							else if(b.enCurso) return 1;
							else return 0;
						});
					}
					else this.actividades = [];
					this.idPersona = response.data.idPersona;
				})
				.catch(console.log)
				.finally(() => {
					this.loading = false;
				});
		},
		initialize() {
			this.getActividades();
		},
		onClickCard(actividad) {
			this.$emit("change", actividad);
		},
	},
};
</script>